import {
  Component,
  Input,
  ViewChild,
  OnInit,
  ViewContainerRef,
  OnDestroy,
} from "@angular/core";
import { SubSink } from "subsink";
import { ActivatedRoute } from "@angular/router";

import { ZoneComponent } from "@/shared-module/components";
import { Configuration, TeamSelectorDatasource } from "@/shared-module/models";
import { ConfigurationService } from "@/shared-module/services";

@Component({
  selector: "app-teamselector",
  templateUrl: "teamselector.component.html",
})
export class TeamSelectorComponent implements OnInit, ZoneComponent, OnDestroy {
  @Input() data: TeamSelectorDatasource;
  @Input() width: number;
  @Input() needpaddingLeft: boolean;
  @Input() isZoom: boolean;
  @ViewChild("template", { static: true }) template;
  regionId: number;
  subs = new SubSink();
  simulation: string;
  highContrast: boolean;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private route: ActivatedRoute,
    private configurationService: ConfigurationService,
  ) {
    this.subs.sink = this.route.queryParams.subscribe((p) => {
      this.regionId = p.region;
    });
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        this.highContrast = c.highContrast;
        this.simulation = c.simulation;
      },
    );
  }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
